import { Link } from "react-scroll";
import { Box, ButtonStyled } from "../../styled/Elements";
import { HeaderContainer } from "./Styled";
import { NavData } from "../../data/data";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BsJustify, BsX } from "react-icons/bs";
import { Container } from "react-bootstrap";
import React, { useContext, useEffect, useState } from "react";
import ChangeButton from "../../../languages/ChangeButton";
import { Logo } from "../../styled/AllImages";
import { AuthContext } from "../../../context/authContext";

const Header = ({ btnLabel, btnUrl }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isAuthenticated } = useContext(AuthContext);
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const [isSticky, setIsSticky] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const handleToggle = () => {
    setToggle(!toggle);
    const element = document.querySelector(".nav-bar-list");
    element.classList.toggle("showToggle");
  };

  const handleSignupButton = () => {
    navigate(btnUrl);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 1) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const authActions = isAuthenticated ? (
    <ButtonStyled
      label={t("my_profile")}
      bg="var(--themeColorSecondary)"
      color="var(--white)"
      clName="signin-btn loginBtn"
      onClick={() => navigate("/my-profile")}
    />
  ) : (
    <>
      <ButtonStyled
        label={t("login")}
        bg="var(--themeColorSecondary)"
        color="var(--white)"
        clName="signin-btn loginBtn"
        onClick={() => navigate("/login")}
      />
      <ButtonStyled
        label={t(btnLabel)}
        color="var(--white)"
        bg="var(--themeColor)"
        clName={"signup-btn"}
        onClick={handleSignupButton}
      />
    </>
  );

  return (
    <>
      <HeaderContainer
        className={`${isSticky ? "sticky" : ""} container-fluid`}
      >
        <Container>
          <Box className="nav-bar">
            <Box className="logo" onClick={() => navigate("/")}>
              <Logo style={{ width: "80px", height: "80px" }} />
            </Box>
            <Box className="nav-bar-list">
              {NavData.map((item, key) => (
                <Box key={key}>
                  <Link
                    to={item.to}
                    spy={true}
                    smooth={true}
                    offset={-90}
                    duration={500}
                    activeClass="active"
                    onClick={handleToggle}
                  >
                    {item?.to === "how-it-works" &&
                    pathname.includes("professionals")
                      ? t("how_it_works")
                      : t(item.label)}
                  </Link>
                </Box>
              ))}
              {windowWidth < 768 ? (
                isAuthenticated ? (
                  <ButtonStyled
                    color="#fff !important"
                    label={t("my_profile")}
                    bg="var(--themeColorSecondary)"
                    onClick={() => navigate("/my-profile")}
                    className="mx-3 mt-2"
                    style={{ marginBottom: "15px" }}
                  />
                ) : (
                  <ButtonStyled
                    color="#fff !important"
                    label={t(btnLabel)}
                    bg="var(--themeColor)"
                    onClick={handleSignupButton}
                    className="mx-3 mt-2"
                    style={{ marginBottom: "15px" }}
                  />
                )
              ) : null}
            </Box>
            <Box className="whtLngWrapper d-flex align-items-center justify-content-center">
              <ChangeButton bg="transparent" color="var(--text)" />
              {authActions}
            </Box>
            <span className="toggleBtn" onClick={handleToggle}>
              {toggle ? <BsX size={30} /> : <BsJustify size={30} />}
            </span>
          </Box>
        </Container>
      </HeaderContainer>
    </>
  );
};

export default Header;
